import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SuccessMessage = ({ mobile, onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="text-center space-y-6 py-8 animate-slide-down">
      <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto">
        <div className="w-16 h-16 bg-success/20 rounded-full flex items-center justify-center">
          <Icon name="CheckCircle" size={32} color="var(--color-success)" />
        </div>
      </div>

      <div className="space-y-2">
        <h2 className="text-2xl font-bold text-foreground">Authentication Successful!</h2>
        <p className="text-muted-foreground">
          Mobile number <span className="font-semibold text-foreground">+91 {mobile}</span> verified
        </p>
      </div>

      <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
        <Icon name="Loader2" size={16} className="animate-spin" />
        <span>Redirecting to dashboard...</span>
      </div>
    </div>
  );
};

export default SuccessMessage;